export default "__VITE_ASSET__CaiDkMOj__"